import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view.
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

// Masked line reveal — the OUTER (untransformed) wrapper is observed so the
// IntersectionObserver isn't deadlocked by the clipped/translated child.
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className="block overflow-hidden"
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-10% 0px" }}
  >
    <motion.span
      className={"block " + className}
      variants={{ hidden: { y: "115%" }, show: { y: "0%" } }}
      transition={{ duration: 0.9, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export default Reveal;
